import React from "react";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";

function UpitIcon(props) {
  return <LiveHelpIcon {...props}/>;
}

export default UpitIcon;
